var _filter, _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-1lwsfp3",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r18:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21,
    width: 20,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_13_20100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_20100",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r18:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.9102,
    y1: 4.5158,
    y2: 20.7203
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Ui-outlineFilter",
    filter: "url(#:r18:-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m20.1 4.8h-2.7v-.9c0-.23869-.0948-.46761-.2636-.6364-.1688-.16878-.3977-.2636-.6364-.2636h-9c-.2387 0-.46761.09482-.6364.2636-.16878.16879-.2636.39771-.2636.6364v.9h-2.7c-.23869 0-.46761.09482-.6364.2636-.16878.16879-.2636.39771-.2636.6364v2.7c0 .95478.37928 1.8705 1.05442 2.5456.67513.6751 1.5908 1.0544 2.54558 1.0544h1.386c.81408.9082 1.91165 1.5141 3.114 1.719v1.881h-.9c-.71608 0-1.40284.2845-1.90919.7908-.50635.5064-.79081 1.1931-.79081 1.9092v1.8c0 .2387.09482.4676.2636.6364.16879.1688.3977.2636.6364.2636h7.2c.2387 0 .4676-.0948.6364-.2636s.2636-.3977.2636-.6364v-1.8c0-.7161-.2845-1.4028-.7908-1.9092-.5064-.5063-1.1931-.7908-1.9092-.7908h-.9v-1.881c1.2023-.2049 2.2999-.8108 3.114-1.719h1.386c.9548 0 1.8705-.3793 2.5456-1.0544s1.0544-1.59082 1.0544-2.5456v-2.7c0-.23869-.0948-.46761-.2636-.6364-.1688-.16878-.3977-.2636-.6364-.2636zm-13.5 5.4c-.47739 0-.93523-.1896-1.27279-.52721-.33757-.33756-.52721-.7954-.52721-1.27279v-1.8h1.8v1.8c.00198.61354.10851 1.22225.315 1.8zm7.2 7.2c.2387 0 .4676.0948.6364.2636s.2636.3977.2636.6364v.9h-5.4v-.9c0-.2387.09482-.4676.2636-.6364.16879-.1688.39771-.2636.6364-.2636zm1.8-9c0 .95478-.3793 1.8705-1.0544 2.5456s-1.5908 1.0544-2.5456 1.0544-1.8705-.3793-2.54558-1.0544c-.67514-.6751-1.05442-1.59082-1.05442-2.5456v-3.6h7.2zm3.6 0c0 .47739-.1896.93523-.5272 1.27279-.3376.33761-.7954.52721-1.2728.52721h-.315c.2065-.57775.313-1.18646.315-1.8v-1.8h1.8z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1 4.8h-2.7v-.9c0-.23869-.0948-.46761-.2636-.6364-.1688-.16878-.3977-.2636-.6364-.2636h-9c-.2387 0-.46761.09482-.6364.2636-.16878.16879-.2636.39771-.2636.6364v.9h-2.7c-.23869 0-.46761.09482-.6364.2636-.16878.16879-.2636.39771-.2636.6364v2.7c0 .95478.37928 1.8705 1.05442 2.5456.67513.6751 1.5908 1.0544 2.54558 1.0544h1.386c.81408.9082 1.91165 1.5141 3.114 1.719v1.881h-.9c-.71608 0-1.40284.2845-1.90919.7908-.50635.5064-.79081 1.1931-.79081 1.9092v1.8c0 .2387.09482.4676.2636.6364.16879.1688.3977.2636.6364.2636h7.2c.2387 0 .4676-.0948.6364-.2636s.2636-.3977.2636-.6364v-1.8c0-.7161-.2845-1.4028-.7908-1.9092-.5064-.5063-1.1931-.7908-1.9092-.7908h-.9v-1.881c1.2023-.2049 2.2999-.8108 3.114-1.719h1.386c.9548 0 1.8705-.3793 2.5456-1.0544s1.0544-1.59082 1.0544-2.5456v-2.7c0-.23869-.0948-.46761-.2636-.6364-.1688-.16878-.3977-.2636-.6364-.2636zm-13.5 5.4c-.47739 0-.93523-.1896-1.27279-.52721-.33757-.33756-.52721-.7954-.52721-1.27279v-1.8h1.8v1.8c.00198.61354.10851 1.22225.315 1.8zm7.2 7.2c.2387 0 .4676.0948.6364.2636s.2636.3977.2636.6364v.9h-5.4v-.9c0-.2387.09482-.4676.2636-.6364.16879-.1688.39771-.2636.6364-.2636zm1.8-9c0 .95478-.3793 1.8705-1.0544 2.5456s-1.5908 1.0544-2.5456 1.0544-1.8705-.3793-2.54558-1.0544c-.67514-.6751-1.05442-1.59082-1.05442-2.5456v-3.6h7.2zm3.6 0c0 .47739-.1896.93523-.5272 1.27279-.3376.33761-.7954.52721-1.2728.52721h-.315c.2065-.57775.313-1.18646.315-1.8v-1.8h1.8z",
    fill: "url(#:r18:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m6.1 8.40161c.00136.42001.04756.83795.13736 1.24679-.20844-.06056-.40036-.17292-.5566-.32916-.2438-.2438-.38076-.57446-.38076-.91924v-1.3h.8v1.3zm11.8-.00161v-1.3h.8v1.3c0 .34478-.137.67544-.3808.91924-.1562.15624-.3481.2686-.5566.32916.0898-.40884.136-.82678.1374-1.24679zm2.2-4.1h-2.2v-.4c0-.3713-.1475-.7274-.4101-.98995-.2625-.26255-.6186-.41005-.9899-.41005h-9c-.3713 0-.7274.1475-.98995.41005s-.41005.61865-.41005.98995v.4h-2.2c-.3713 0-.7274.1475-.98995.41005s-.41005.61865-.41005.98995v2.7c0 1.08739.43196 2.1302 1.20086 2.8991s1.81175 1.2009 2.89914 1.2009h1.16859c.77296.7983 1.75486 1.3611 2.83141 1.6255v.9745h-.4c-.84869 0-1.66263.3371-2.26274.9373-.60012.6001-.93726 1.414-.93726 2.2627v1.8c0 .3713.1475.7274.41005.99.26255.2625.61865.41.98995.41h7.2c.3713 0 .7274-.1475.99-.41.2625-.2626.41-.6187.41-.99v-1.8c0-.8487-.3371-1.6626-.9373-2.2627-.6001-.6002-1.414-.9373-2.2627-.9373h-.4v-.9745c1.0766-.2644 2.0584-.8272 2.8314-1.6255h1.1686c1.0874 0 2.1302-.432 2.8991-1.2009s1.2009-1.81171 1.2009-2.8991v-2.7c0-.3713-.1475-.7274-.41-.98995-.2626-.26255-.6187-.41005-.99-.41005zm-6.3 13.6c.1061 0 .2078.0421.2828.1172.0751.075.1172.1767.1172.2828v.4h-4.4v-.4c0-.1061.04214-.2078.11716-.2828.07501-.0751.17674-.1172.28284-.1172zm1.3-9.5c0 .82217-.3266 1.6107-.908 2.192-.5813.5814-1.3698.908-2.192.908s-1.6107-.3266-2.19203-.908c-.58136-.5813-.90797-1.36983-.90797-2.192v-3.1h6.2z",
    stroke: "#5800e9",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.d0d633dff31c46123171e7a63d1c1370.svg";
export { ForwardRef as ReactComponent };